import React from "react";
import { ActionIcon, Group, Text } from "@mantine/core";
import { AggregationOption, DEFAULT_AGGREGATION_OPTIONS } from "./chartUtils";
import { AggregationValue } from "./types";

interface AggregationToggleGroupProps {
    value: AggregationValue;
    onChange: (value: AggregationValue) => void;
    options?: AggregationOption[];
    disabled?: boolean;
}

export const AggregationToggleGroup: React.FC<AggregationToggleGroupProps> = ({ value, onChange, options = DEFAULT_AGGREGATION_OPTIONS, disabled }) => (
    <Group gap={2} style={{ flexWrap: "nowrap" }}>
        {options.map(option => (
            <ActionIcon
                key={option.value}
                size="sm"
                variant={value === option.value ? "filled" : "light"}
                color={value === option.value ? "blue" : "gray"}
                onClick={() => onChange(option.value)}
                disabled={disabled}
                title={option.label}
            >
                <Text size="xs" fw={600}>
                    {option.short}
                </Text>
            </ActionIcon>
        ))}
    </Group>
);
